<form (ngSubmit)="onSubmit(inviteForm.getFormData())" snDrawer>
  <sn-drawer-header [title]="headerTitle">
    <sn-drawer-header-actions>
      <sn-icon-button icon="close" snDrawerClose snDrawerNavButton></sn-icon-button>
    </sn-drawer-header-actions>
    <div *ngIf="subheaderText" class="share-invite-drawer-v2__subheader">
      {{ subheaderText }}
    </div>
  </sn-drawer-header>

  <sn-drawer-content indented>
    <fs-share-invite-form-v2
      #inviteForm
      [form]="form"
      [formModel]="formModel"
      [additionalFields]="additionalFields"
    >
    </fs-share-invite-form-v2>
  </sn-drawer-content>

  <sn-drawer-footer class="share-invite-drawer-v2__footer">
    <sn-flat-button type="button" snDrawerClose class="share-invite-drawer-v2__footer-button">{{ 'common.cancel' | t }}</sn-flat-button>
    <sn-flat-button color="accent" type="submit" [disabled]="form.invalid" class="share-invite-drawer-v2__footer-button">{{ 'common.share' | t }} {{ contentTypeDisplay }}</sn-flat-button>
  </sn-drawer-footer>
</form>
